<template>
  <div class="nameAndIdentitycard-wrap">
    <div class="tip-bar">
      <van-icon name="info-o" class="tip-icon" />
      <span>为了保证电子签约的法律效力，您需要先进行实名认证</span>
    </div>

    <div class="form-card">
      <div class="field-group">
        <div class="label">姓名</div>
        <van-field v-model="userFullName" @input="onInput" placeholder="请输入真实姓名" :disabled="disabled" />
      </div>
      <div class="field-group">
        <div class="label">证件号</div>
        <van-field v-model="userIdCardNo" maxlength="18" placeholder="请输入证件号" :disabled="disabled" />
      </div>
      <div class="field-group field-group-last">
        <div class="label">证件类型</div>
        <van-cell is-link @click="showPopup">{{ typeStr }}</van-cell>
      </div>
    </div>

    <!-- 证件照片逻辑（已注释，方便恢复）
    <div class="form-card">
      <div class="card-head">
        <span class="card-title">证件照片</span>
        <span class="card-desc">请上传身份证人像面和国徽面</span>
      </div>
      <div class="id-uploads">
        <div class="id-upload-item" v-for="item in idCardSides" :key="item.key">
          <van-uploader :after-read="(file) => afterReadIdCard(file, item.key)" :max-count="1"
            :max-size="5 * 1024 * 1024" @oversize="onOversize">
            <div class="id-upload-box">
              <van-loading v-if="item.loading" type="spinner" color="#1676FF" size="24" />
              <img v-else-if="item.url" :src="item.url" class="id-preview" />
              <div v-else class="id-placeholder">
                <van-icon name="photograph" size="28" color="#C8D0DE" />
              </div>
            </div>
          </van-uploader>
          <div class="id-upload-label">{{ item.label }}</div>
        </div>
      </div>
    </div>
    -->

    <div class="footer" v-if="!isPopup">
      <template v-if="canClick">
        <div class="btn" @click="twoElements">下一步</div>
      </template>
      <template v-else>
        <div class="btn btn2">下一步</div>
      </template>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-picker title="标题" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel"
        @change="onChange" />
    </van-popup>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { hasCookies } from '@/utils/cookies'
import Api from '@/api'
import myApis from '@/api/my'
import AuthApi from '@/api/creadit'
import caApi from '@/api/ca'
// import Apifiles from '@/api/files' // 证件照逻辑（已注释，方便恢复）
import { Dialog, Toast } from 'vant'
import { mapState } from 'vuex'

export default {
  props: ['isPopup'],
  data() {
    return {
      userFullName: '',
      userIdCardNo: '',
      checked: true,
      disabled: false,
      token: undefined,
      show: false,
      // columns: ['中国居民身份证', '台胞证/台湾居民来往内地通行证', '港澳居民来往内地通行证'],
      columns: ['中国居民身份证'],
      typeStr: '中国居民身份证',
      type: 1,
      loading: false,
      // 证件照逻辑（已注释，方便恢复）
      // frontUrl: '', // 人像面 本地预览(base64)
      // frontImgKey: '', // 人像面 fileKey
      // frontUploading: false,
      // backUrl: '', // 国徽面 本地预览
      // backImgKey: '', // 国徽面 fileKey
      // backUploading: false,
    }
  },
  computed: {
    ...mapState({
      systemInfo: state => state.system,
    }),
    canClick() {
      if (
        this.userFullName &&
        this.userIdCardNo &&
        this.checked
        // 证件照逻辑（已注释，方便恢复）
        // && this.frontImgKey &&
        // this.backImgKey
      )
        return true
      return false
    },
    /* 证件照逻辑（已注释，方便恢复）
    idCardSides() {
      return [
        {
          key: 'front',
          label: '人像面',
          url: this.frontUrl,
          loading: this.frontUploading,
        },
        {
          key: 'back',
          label: '国徽面',
          url: this.backUrl,
          loading: this.backUploading,
        },
      ]
    },
    */
  },
  async created() {
    // this.$store.dispatch('resetSession')
    const { token, resetAuth } = this.$route.query
    if (token) {
      this.token = token
    }
    this.toast = Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
    })
    // 重新填写信息认证
    /* eslint-disable-next-line */
    if (resetAuth == 1) {
      this.tokenInfo = this.$jsonPase(
        window.sessionStorage.getItem('tokenInfo')
      )
      if (this.tokenInfo) {
        this.setCreditType = this.tokenInfo.type
      } else {
        this.tokenInfo = {}
        this.setCreditType = 2 // 如果回来的时候没有 tokenInfo 则说明是从发起签署到实名认证页面的，要将数据从store中取出来
        // 刷新页面后 store 的 userInfo 会被清空(userId 为 undefined)，需重新拉取
        if (hasCookies() && !this.$store.getters.getUserInfo?.userId) {
          await this.$store.dispatch('fetchUserInfo')
        }
        this.userInfo = this.$store.getters.getUserInfo || {}
        this.tokenInfo.telephone = this.userInfo.telephone
        this.tokenInfo.userId = this.userInfo.userId
        this.tokenInfo.creditStatus = this.userInfo.creditStatus
      }
      this.getUserInfo()
      return
    }
    if (token) {
      this.getCreditTokenInfo(token)
    } else {
      this.tokenInfo = this.$jsonPase(
        window.sessionStorage.getItem('tokenInfo')
      ) || {}
      this.userInfo = this.$store.state.user.userInfo
      this.tokenInfo.telephone = this.userInfo.telephone
      this.tokenInfo.userId = this.userInfo.userId
      this.tokenInfo.creditStatus = this.userInfo.creditStatus
      window.sessionStorage.setItem(
        'tokenInfo',
        JSON.stringify(this.tokenInfo)
      )
      this.setCreditType = this.tokenInfo.type
      this.getUserInfo()
    }
  },
  methods: {
    showPopup() {
      this.show = true
    },
    onConfirm(value, index) {
      this.typeStr = value
      this.type = index + 1
      this.show = false
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`)
    },
    onCancel() {
      this.show = false
    },
    onInput(value) {
      this.userFullName = value.replace(/[\d]/g, '')
    },
    /* 证件照逻辑（已注释，方便恢复）
    onOversize() {
      Toast('图片大小不能超过 5M')
    },
    async afterReadIdCard(file, side) {
      const imgType = `.${file.file.name
        .split('.')
        .pop()
        .toLowerCase()}`
      if (!['.jpg', '.jpeg', '.png'].includes(imgType)) {
        Toast('仅支持 jpg、png 格式')
        return
      }
      this[`${side}Uploading`] = true
      this[`${side}Url`] = file.content // 本地预览
      try {
        const { fileKey } = await Apifiles.uploadFile({
          objectBase64: file.content,
          objectFormat: imgType,
          userId: this.tokenInfo.userId,
          comId: this.tokenInfo.comId,
        })
        this[`${side}ImgKey`] = fileKey
      } catch (err) {
        Toast('上传失败，请重试')
        this[`${side}Url`] = ''
        console.log(err)
      } finally {
        this[`${side}Uploading`] = false
      }
    },
    */
    async getUserInfo() {
      const { comId, userId } = this.tokenInfo
      try {
        // userInfo 已有姓名和证件号时，带出并锁定不可编辑
        const userInfo = this.$store.state.user.userInfo || {}
        if (userInfo.name && userInfo.idCardNo) {
          this.userFullName = userInfo.name
          this.userIdCardNo = userInfo.idCardNo
          this.disabled = true
        }
        const { caStatus } = await caApi.getCaStatus()
        // 认证成功
        if (caStatus !== 0) {
          await this.$router.push(
            `/authenticationSuccess?redirectUrl=${this.$route.query.redirectUrl}`
          )
          this.toast.clear()
          return
          // 个人实名
          //   if (this.setCreditType === 2) {
          //     await this.$router.push(
          //       `/authenticationSuccess?redirectUrl=${this.$route.query.redirectUrl}`
          //     )
          //     this.toast.clear()
          //     return
          //   }
          //   const comAuthStatus = await AuthApi.getComAuthStatus({
          //     comId,
          //     userId,
          //   })
          //   this.toast.clear()
          //   // 已签署授权书
          //   if (comAuthStatus === 7) {
          //     this.$router.push('/signSuccess')
          //     return
          //   }
          //   // 未签署授权书
          //   this.$router.push('/signCreaditBook')
          // } else {
          //   // 未实名的情况
          //   this.toast.clear()
          //   if (this.setCreditType !== 2) {
          //     this.$store.commit('setCreditType', 1)
          //   }
        }
        // 未实名
      } catch (err) {
        this.toast.clear()
        console.log(err)
      }
    },
    async getCreditTokenInfo(creditToken) {
      const res = await AuthApi.getCreditTokenInfo({ creditToken })
      // 0 分享给法人认证 1 法人认证  2 个人实名
      if (res.type === 0 && hasCookies()) {
        const data = await myApis.getUserInfo()
        res.creditStatus = data.creditStatus
        res.telephone = data.telephone
        res.email = data.email
        res.userId = data.userId
      }
      window.sessionStorage.setItem('tokenInfo', JSON.stringify(res))
      this.$store.commit('setCreditType', res.type)
      this.setCreditType = res.type
      if (res.type === 0 && !hasCookies()) {
        this.$router.replace(
          `/login?redirect=/nameAndIdentitycard?token=${this.token}`
        )
        this.toast.clear()
        return
      }
      this.tokenInfo = res
      this.userInfo = res
      this.getUserInfo()
    },
    async twoElements() {
      if (this.loading) return
      // 证件照校验逻辑（已注释，方便恢复）
      // if (!this.frontImgKey || !this.backImgKey) {
      //   Toast('请上传身份证人像面和国徽面')
      //   return
      // }
      let { userId } = this.tokenInfo
      if (this.tokenInfo.type === 0 && hasCookies()) {
        userId = Cookies.get('userId')
      }
      this.loading = true
      // 已认证：跳过二要素校验，直接进入下一步
      try {
        const { creditStatus } = await caApi.getCaStatus()
        if (creditStatus !== 0) {
          const info = {
            // 证件照逻辑（已注释，方便恢复）
            // idCardBack: this.backImgKey,
            // idCardFront: this.frontImgKey,
            idcardNo: this.userIdCardNo,
            userName: this.userFullName,
          }
          sessionStorage.setItem('auth_info', JSON.stringify(info))
          if (this.type !== 1) {
            await this.$store.dispatch('fetchUserInfo')
            const { resetAuth } = this.$route.query
            this.$router.push({
              name: '/authenticationSuccess',
              query: {
                resetAuth,
              },
            })
          } else {
            this.$store.commit('setCreditMsg', {
              userFullName: this.userFullName,
              userIdCardNo: this.userIdCardNo,
              userId,
              telephone: this.tokenInfo.telephone,
            })
            const { redirectUrl } = this.$route.query
            this.$router.push({
              name: 'auth',
              query: {
                redirectUrl,
              },
            })
          }
          return
        }
      } catch (e) {
        console.log(e)
      }
      Api.twoElements({
        userFullName: this.userFullName,
        userIdCardNo: this.userIdCardNo,
        userId,
        systemId: this.systemInfo.systemId,
        type: this.type,
      })
        .then(async res => {
          const { data, status, msg } = res
          if (status === 201 && this.$store.state.setCreditType === 2) {
            Dialog.alert({
              title: '',
              message: msg,
              confirmButtonText: '重新输入',
            }).then(() => {
              this.userFullName = ''
              this.userIdCardNo = ''
            })
            return
          }
          // 要求：有没有「上限」两个字的时候展示以下错误信息
          if (
            status === 201 &&
            !msg.includes('上限') &&
            !msg.includes('已绑定')
          ) {
            Dialog.alert({
              title: '身份信息校验错误',
              message: `<p>1、检查姓名和身份证填写是否正确</p> <p>2、检查填写的身份证填写是否有效</p> <p>3、检查填写的姓名是否有效</p>`,
              allowHtml: true,
            })
            return
          }
          if (status === 200) {
            const info = {
              // 证件照逻辑（已注释，方便恢复）
              // idCardBack: this.backImgKey,
              // idCardFront: this.frontImgKey,
              idcardNo: this.userIdCardNo,
              userName: this.userFullName,
            }
            sessionStorage.setItem('auth_info', JSON.stringify(info))
            if (this.type !== 1) {
              await this.$store.dispatch('fetchUserInfo')
              const { resetAuth } = this.$route.query
              this.$router.push({
                name: '/authenticationSuccess',
                query: {
                  resetAuth,
                },
              })
            } else {
              this.$store.commit('setCreditMsg', {
                userFullName: this.userFullName,
                userIdCardNo: this.userIdCardNo,
                userId,
                telephone: this.tokenInfo.telephone,
              })
              const { redirectUrl } = this.$route.query
              this.$router.push({
                name: 'auth',
                query: {
                  redirectUrl,
                },
              })
            }
            return
          }
          Toast(msg)
        })

        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="less" scoped>
.nameAndIdentitycard-wrap {
  width: 100%;
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 90px;

  .tip-bar {
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    background: #ecf3ff;
    color: #1676ff;
    font-size: 14px;
    line-height: 20px;

    .tip-icon {
      font-size: 16px;
      margin-right: 6px;
      margin-top: 1px;
      flex-shrink: 0;
    }
  }

  .form-card {
    background: #fff;
    border-radius: 8px;
    margin: 12px 16px 0;
    padding: 0 16px;

    .label {
      font-size: 14px;
      font-weight: 400;
      color: #646566;
      line-height: 20px;
      padding-top: 14px;
      margin-bottom: 4px;
    }

    .field-group {
      border-bottom: 1px solid #f2f3f5;
      padding-bottom: 6px;
    }

    .field-group-last {
      border-bottom: none;
    }

    /deep/ .van-cell {
      padding: 8px 0;
      font-size: 14px;
      color: #111a34;
    }

    /deep/ .van-field__control {
      font-size: 14px;
      color: #111a34;
    }
  }

  .card-head {
    display: flex;
    align-items: baseline;
    padding-top: 16px;

    .card-title {
      font-size: 14px;
      font-weight: 500;
      color: #111a34;
    }

    .card-desc {
      font-size: 12px;
      color: #969799;
      margin-left: 8px;
    }
  }

  .id-uploads {
    display: flex;
    justify-content: space-between;
    padding: 12px 0 16px;

    .id-upload-item {
      width: calc(50% - 6px);
      text-align: center;

      /deep/ .van-uploader,
      /deep/ .van-uploader__input-wrapper,
      /deep/ .van-uploader__wrapper {
        width: 100%;
      }

      .id-upload-box {
        width: 100%;
        height: 105px;
        background: #f7f8fa;
        border: 1px dashed #dcdee0;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        .id-preview {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .id-upload-label {
        font-size: 14px;
        color: #646566;
        margin-top: 8px;
      }
    }
  }

  .footer {
    position: fixed;
    bottom: env(safe-area-inset-bottom);
    left: 0;
    width: 100%;
    height: 66px;
    background: #fff;
    box-shadow: 0 -6px 10px 0 rgba(230, 234, 237, 0.3);
    padding-top: 10px;

    .btn {
      width: 327px;
      height: 44px;
      background: #1676ff;
      box-shadow: 0 6px 20px 0 rgba(78, 128, 245, 0.16);
      border-radius: 4px;
      font-size: 18px;
      font-weight: 500;
      color: #fff;
      line-height: 44px;
      text-align: center;
      margin: 0 auto;
    }

    .btn2 {
      background: rgba(22, 118, 255, 0.2);
    }
  }
}
</style>
